/** Job departments. Keyed by job_industry.id.
 * Local fallback. Published Contentful `jobIndustry` titles overlay these by apiId.
 * After Contentful is complete, copy that list back into this file.
 * The API English `name` is never shown in the UI.
 */
export const order = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15];

const dictionary = {
  en: {
    "1": { id: 1, title: "Software, Tech, Product development" },
    "2": { id: 2, title: "Sales, Marketing, Communication" },
    "3": { id: 3, title: "Education & Research" },
    "4": { id: 4, title: "Management" },
    "5": { id: 5, title: "Financial" },
    "6": { id: 6, title: "Customer care" },
    "7": { id: 7, title: "Supervisors" },
    "8": { id: 8, title: "HR, Administration, Office" },
    "9": { id: 9, title: "Legal" },
    "10": { id: 10, title: "Health Care" },
    "11": { id: 11, title: "Security, Protection, military" },
    "12": { id: 12, title: "Transportation and logistics" },
    "13": { id: 13, title: "Jobs creativity needed" },
    "14": { id: 14, title: "Hotel, restaurant, food" },
    "15": { id: 15, title: "Operative jobs" },
  },
  de: {
    "1": { id: 1, title: "Software, Tech, Produktentwicklung" },
    "2": { id: 2, title: "Vertrieb, Marketing, Kommunikation" },
    "3": { id: 3, title: "Bildung & Forschung" },
    "4": { id: 4, title: "Management" },
    "5": { id: 5, title: "Finanzen" },
    "6": { id: 6, title: "Kundenbetreuung" },
    "7": { id: 7, title: "Vorgesetzte" },
    "8": { id: 8, title: "HR, Verwaltung, Büro" },
    "9": { id: 9, title: "Recht" },
    "10": { id: 10, title: "Gesundheitswesen" },
    "11": { id: 11, title: "Sicherheit, Schutz, Militär" },
    "12": { id: 12, title: "Transport und Logistik" },
    "13": { id: 13, title: "Kreative Berufe" },
    "14": { id: 14, title: "Hotel, Gastronomie, Lebensmittel" },
    "15": { id: 15, title: "Operative Tätigkeiten" },
  },
  "fi": {
    "1": {
      "id": 1,
      "title": "Ohjelmistot, teknologia, tuotekehitys"
    },
    "2": {
      "id": 2,
      "title": "Myynti, markkinointi, viestintä"
    },
    "3": {
      "id": 3,
      "title": "Koulutus ja tutkimus"
    },
    "4": {
      "id": 4,
      "title": "Johtaminen"
    },
    "5": {
      "id": 5,
      "title": "Talous"
    },
    "6": {
      "id": 6,
      "title": "Asiakaspalvelu"
    },
    "7": {
      "id": 7,
      "title": "Esihenkilöt"
    },
    "8": {
      "id": 8,
      "title": "Henkilöstöhallinto, hallinto, toimisto"
    },
    "9": {
      "id": 9,
      "title": "Lakiasiat"
    },
    "10": {
      "id": 10,
      "title": "Terveydenhuolto"
    },
    "11": {
      "id": 11,
      "title": "Turvallisuus, vartiointi, puolustusvoimat"
    },
    "12": {
      "id": 12,
      "title": "Liikenne ja logistiikka"
    },
    "13": {
      "id": 13,
      "title": "Luovat työt"
    },
    "14": {
      "id": 14,
      "title": "Hotelli-, ravintola- ja ruoka-ala"
    },
    "15": {
      "id": 15,
      "title": "Operatiiviset työt"
    }
  }
};

export default dictionary;
